import { POST } from "../../index";

export const getSafetySurvey = (param) => POST("/v1/jurisdictionSafety/getSafetySurvey", param);
export const getViolationTrend = (param) => POST("/v1/jurisdictionSafety/getViolationTrend", param);
export const getViolationAnalysis = (param) => POST("/v1/jurisdictionSafety/getViolationAnalysis", param);
export const getCarViolationDetail = (param) => POST("/v1/jurisdictionSafety/getCarViolationDetail", param);

